// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards {
  display: flex;
  flex-wrap: wrap;
  flex-direction: repeat(3, column);
  margin-bottom: 100px;
}

/* FORM - COLUNAS  */

.primeira-col-2 {
  justify-content: start;
  justify-self: start;
}

.segunda-col {
  padding-left: 45px;
  justify-content: start;
  justify-self: start;
}

.terceira-col {
  margin-left: auto;
}

.font {
  font-size: 26px;
}
`, "",{"version":3,"sources":["webpack://./src/components/sobre-aluno/sobre-aluno-style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,oBAAoB;;AAEpB;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".cards {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: repeat(3, column);\n  margin-bottom: 100px;\n}\n\n/* FORM - COLUNAS  */\n\n.primeira-col-2 {\n  justify-content: start;\n  justify-self: start;\n}\n\n.segunda-col {\n  padding-left: 45px;\n  justify-content: start;\n  justify-self: start;\n}\n\n.terceira-col {\n  margin-left: auto;\n}\n\n.font {\n  font-size: 26px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
